import type { ClientFilters, InvoiceFilters } from '@getpay93/api';

export const qk = {
  dashboardSummary: ['dashboard', 'summary'] as const,
  upcoming: ['dashboard', 'upcoming'] as const,
  revenueMonthly: (m: number) => ['dashboard', 'revenue', m] as const,
  health: ['dashboard', 'health'] as const,
  onboarding: ['onboarding'] as const,
  clients: (f: ClientFilters) => ['clients', f] as const,
  client: (id: string) => ['client', id] as const,
  clientPlans: (clientId: string) => ['clientPlans', clientId] as const,
  plans: ['plans'] as const,
  invoices: (f: InvoiceFilters) => ['invoices', f] as const,
  proofs: (status?: string) => ['proofs', status ?? 'all'] as const,
  mePlan: ['mePlan'] as const,
  unreadCount: ['notifications', 'unreadCount'] as const,
  notifications: ['notifications', 'list'] as const,
  invites: ['invites'] as const,
  report: (y: number, m: number) => ['report', y, m] as const,
  referrals: ['referrals', 'mine'] as const,
  reminders: ['settings', 'reminders'] as const,
  org: ['org'] as const,
  providers: ['providers'] as const,
  clientView: ['clientView'] as const,
  coaches: ['coaches'] as const,
  myProofs: ['proofs', 'mine'] as const,
};
